(function () {
	function initFaqAccordions() {
		const accordions = document.querySelectorAll('[data-faq-accordion]');

		accordions.forEach(function (accordion) {
			if (accordion.dataset.faqInitialized) {
				return;
			}
			accordion.dataset.faqInitialized = 'true';

			const items = accordion.querySelectorAll('[data-faq-item]');

			items.forEach(function (item) {
				const trigger = item.querySelector('.faq__trigger');
				const content = item.querySelector('.faq__content');

				if (!trigger || !content) return;

				trigger.addEventListener('click', function () {
					const isOpen = item.classList.contains('is-open');

					if (isOpen) {
						closeItem(item, trigger, content);
					} else {
						openItem(item, trigger, content);
					}
				});
			});
		});
	}

	function openItem(item, trigger, content) {
		item.classList.add('is-open');
		trigger.setAttribute('aria-expanded', 'true');
		content.removeAttribute('hidden');

		content.style.maxHeight = '0px';
		// Force reflow
		content.offsetHeight;
		content.style.maxHeight = content.scrollHeight + 'px';

		const onTransitionEnd = function () {
			content.style.maxHeight = 'none';
			content.removeEventListener('transitionend', onTransitionEnd);
		};
		content.addEventListener('transitionend', onTransitionEnd);
	}

	function closeItem(item, trigger, content) {
		content.style.maxHeight = content.scrollHeight + 'px';
		// Force reflow
		content.offsetHeight;
		content.style.maxHeight = '0px';

		item.classList.remove('is-open');
		trigger.setAttribute('aria-expanded', 'false');

		const onTransitionEnd = function () {
			if (!item.classList.contains('is-open')) {
				content.setAttribute('hidden', '');
			}
			content.removeEventListener('transitionend', onTransitionEnd);
		};
		content.addEventListener('transitionend', onTransitionEnd);
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', initFaqAccordions);
	} else {
		initFaqAccordions();
	}
})();
